import styles from "./TopSingleCard.module.css";
import "../../fonts/Futura-PT-Book.ttf";

import warning_icon from "../../assets/images/icons/warning_icon.png";

import arrow_icon from "../../assets/images/icons/arrow_icon.png";
const TopSingleCard = ({
  icon = "",
  headingText = "",
  description = "",
  fontFamily = "Futura Book PT, sans-serif",
  fontSize = "20px",
  letterSpacing = "1px",
  fontWeight = 600,
  iconHeight = "21px",
  iconWidth = "21px",
  warning = false,
  bottomWarningText = "",
}) => {
  return (
    <>
      <div className={styles.single_card_div}>
        <img
          src={arrow_icon}
          className={styles.arrow_icon_main}
          alt="arrow icon"
        />
        <div className={styles.single_card_heading}>
          {warning && (
            <div
              className={styles.show_info}
              style={{
                top:
                  headingText === "Design"
                    ? "35px"
                    : headingText === "Gallery"
                    ? "33px"
                    : "36px",
                left:
                  headingText === "Design"
                    ? "80px"
                    : headingText === "Gallery"
                    ? "83px"
                    : "53px",
              }}
            >
              <img
                className={styles.warning_img}
                src={warning_icon}
                alt="warning"
              />
            </div>
          )}
          <div className={styles.sch_main}>
            {icon !== "" && (
              <img
                src={icon}
                style={{ width: iconWidth, height: iconHeight }}
                alt={headingText}
              />
            )}
            <div
              className={styles.single_card_heading_text}
              style={{
                fontFamily: fontFamily,
                fontSize: fontSize,
                letterSpacing: letterSpacing,
                fontWeight: fontWeight,
              }}
            >
              {headingText}
            </div>
          </div>
        </div>
        <div className={styles.single_card_div_middle_line}></div>
        <div className={styles.single_card_description_div}>
          {Array.isArray(description) &&
            description.length > 0 &&
            description.map((item, index) => {
              return <div>{item}</div>;
            })}
        </div>
        {bottomWarningText && (
          <div className={styles.bottomWarningText}>{bottomWarningText}</div>
        )}
      </div>
    </>
  );
};
export default TopSingleCard;
